export enum Organization {
  OPEN_ENGLISH = 'OpenEnglish',
  NEXTU = 'NextU',
  OPEN_ENGLISH_JR = 'OpenEnglishJunior',
  OPEN_ENGLISH_ADULT = 'OpenEnglishAdult',
  OPEN_MUNDO = 'OpenMundo',
}
